import React from "react";
import { toast } from "react-toastify";
import { getImageUploadsError, IMAGE_UPLOAD_ACCEPT, IMAGE_UPLOAD_HELP } from "../../../utils/imageUpload";

function Itinerary({ itinerary, setItinerary }) {

    const addItineraryItem = () => {
        setItinerary(prev => [
            ...prev,
            {
                start_time: "",
                end_time: "",
                title: "",
                location: "",
                description: "",
                travel_mode: "",
                duration: "",
                images: [],        // <-- NEW
                map_link: "",      // <-- NEW (Google Maps link or lat,lng)
                is_optional: false,
            }
        ]);
    };

    const removeItineraryItem = (index) => {
        setItinerary(prev => prev.filter((_, i) => i !== index));
    };

    const updateItinerary = (index, field, value) => {
        setItinerary(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };

    // Handle image selection (max 5)
    const handleImageChange = (index, files) => {
        const fileArray = Array.from(files).slice(0, 5); // limit 5
        const imageError = getImageUploadsError(fileArray);
        if (imageError) {
            toast.error(imageError);
            return;
        }

        setItinerary(prev =>
            prev.map((item, i) =>
                i === index ? { ...item, images: fileArray } : item
            )
        );
    };

    return (
        <section className="space-y-4 mt-6 border-t pt-4">


            <div className="flex justify-end">
                <button
                    onClick={addItineraryItem}
                    type="button"
                    className="px-2 py-1 bg-gray-100 rounded"
                >
                    +
                </button>
            </div>

            {itinerary.map((item, index) => (
                <div key={index} className="border p-4 rounded-md space-y-4 bg-gray-50">

                    <div className="flex justify-between items-center">
                        <h4 className="font-medium">Stop {index + 1}</h4>
                        {index > 0 && (
                            <button
                                onClick={() => removeItineraryItem(index)}
                                className="text-red-600 text-sm"
                            >
                                Remove
                            </button>
                        )}
                    </div>

                    {/* TIME */}
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm text-gray-600">Start Time</label>
                            <input
                                type="time"
                                className="w-full p-2 border rounded"
                                value={item.start_time}
                                onChange={(e) =>
                                    updateItinerary(index, "start_time", e.target.value)
                                }
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">End Time</label>
                            <input
                                type="time"
                                className="w-full p-2 border rounded"
                                value={item.end_time}
                                onChange={(e) =>
                                    updateItinerary(index, "end_time", e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* TITLE */}
                    <div>
                        <label className="text-sm text-gray-600">Title</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={item.title}
                            onChange={(e) =>
                                updateItinerary(index, "title", e.target.value)
                            }
                        />
                    </div>

                    {/* LOCATION */}
                    <div>
                        <label className="text-sm text-gray-600">Location</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={item.location}
                            onChange={(e) =>
                                updateItinerary(index, "location", e.target.value)
                            }
                        />
                    </div>

                    {/* DESCRIPTION */}
                    <div>
                        <label className="text-sm text-gray-600">Description</label>
                        <textarea
                            className="w-full p-2 border rounded"
                            rows={3}
                            value={item.description}
                            onChange={(e) =>
                                updateItinerary(index, "description", e.target.value)
                            }
                        />
                    </div>

                    {/* TRAVEL MODE + DURATION */}
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm text-gray-600">Travel Mode</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded"
                                value={item.travel_mode}
                                onChange={(e) =>
                                    updateItinerary(index, "travel_mode", e.target.value)
                                }
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">Duration</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded"
                                value={item.duration}
                                onChange={(e) =>
                                    updateItinerary(index, "duration", e.target.value)
                                }
                            />
                        </div>
                    </div>

                    {/* IMAGES (UP TO 5) */}
                    <div>
                        <label className="text-sm text-gray-600">Upload Images (Max 5)</label>
                        <input
                            type="file"
                            accept={IMAGE_UPLOAD_ACCEPT}
                            multiple
                            className="w-full p-2 border rounded"
                            onChange={(e) => handleImageChange(index, e.target.files)}
                        />
                        <p className="mt-1 text-xs text-gray-500">{IMAGE_UPLOAD_HELP}</p>

                        {/* Image Preview */}
                        {item.images?.length > 0 && (
                            <div className="grid grid-cols-3 gap-2 mt-2">
                                {item.images.map((img, i) => (
                                    <img
                                        key={i}
                                        src={URL.createObjectURL(img)}
                                        alt={`stop-${index}-img-${i}`}
                                        className="w-full h-24 object-cover rounded"
                                    />
                                ))}
                            </div>
                        )}
                    </div>

                    {/* MAP LINK / COORDINATES */}
                    <div>
                        <label className="text-sm text-gray-600">
                            Google Map Link (or lat,lng)
                        </label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            placeholder="https://www.google.com/maps?q=12.9716,77.5946"
                            value={item.map_link}
                            onChange={(e) =>
                                updateItinerary(index, "map_link", e.target.value)
                            }
                        />
                    </div>
                </div>
            ))}

        </section>
    );
}

export default Itinerary;
